<template>
  <mc-header
    system-type="vss"
    :background-color="backgroundColorStyle"
    class="vss-header"
  >
    <template #left>
      <div class="left-container">
        <a href="/" class="site-logo">
          <span class="site-logo-img"></span>
        </a>
      </div>
    </template>
    <template #right>
      <McTime />
      <McLang :lx-config="lxConfig" />
      <AccountMenu
        :toggle-account="accountMenuItem"
      />
    </template>
  </mc-header>
</template>

<script>
import { McHeader, McLang, McTime } from "../../common/index";
import { VSS_ACCOUNT_TYPE } from "./constants";
import AccountMenu from "./components/AccountMenu.vue";
import { VSS_COMMUNICATION_EVENTS } from "@/api/event";

export default {
  name: "HeaderMenu",
  inject: ['$$event', '$xxEvent', '$xxMenu', '$xxRouter'],
  components: {
    McHeader,
    McLang,
    McTime,
    AccountMenu,
  },
  props: {
    accountTypeByPath: {
      type: Number,
      default: 0,
    },
    accountInfo: {
      type: Object,
      default: () => ({}),
    },
    supplierInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      lxConfig: {
        cid: "c_osg_b_wq5vyv37",
        changeLangBid: "b_osg_b_6m6tm42w_mc",
        initLangBid: "b_osg_b_6m6tm42w_mv",
      },
      backgroundColorStyle: {
        test: "#fff",
        staging: "#fff",
        production: "#fff",
      },
      showSupplierSelect: false,
      supplierSelectDisable: false,
    };
  },
  computed: {
    accountMenuItem() {
      if (VSS_ACCOUNT_TYPE.length === 0) return {};
      return (
        VSS_ACCOUNT_TYPE.find(
          (item) => item.code === this.getAccountTypeByPath(true)
        ) || {}
      );
    },
    isShowMobileGuideEntry() {
      return (
        this.supplierInfo &&
        this.supplierInfo.supplierDxAccountVO &&
        this.supplierInfo.supplierDxAccountVO.mis &&
        this.supplierInfo.supplierDxAccountVO.domain
      );
    },
  },
  mounted() {
    // 监听子应用传递供货规则选择器属性值的事件
    this.$xxEvent.on(VSS_COMMUNICATION_EVENTS.VSS_HEADER_SUPPLIER_SELECT, (data) => {
      const {
        showSupplierSelect: isShowSupplierSelect,
        supplierSelectDisable: isSupplierSelectDisable,
      } = data;
      this.showSupplierSelect = isShowSupplierSelect;
      this.supplierSelectDisable = isSupplierSelectDisable;
    });
  },
  methods: {
    navigateToReport() {
      window.open("https://jubao.meituan.com/app/home?source=38");
    },
    getAccountTypeByPath(toggle) {
      const pathname = window.location.pathname;
      if (/^\/renxiao|^\/micro\/lmsplat/.test(pathname)) {
        return !toggle ? 1 : 0;
      } else {
        return !toggle ? 0 : 1;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.left-container {
  height: 60px;
  // width: 550px;
  margin-right: 20px;
  display: flex;
}
.site-logo {
  flex: 1;
  display: inline-block;
  width: 100%;
  height: 100%;
  line-height: 60px;
  color: white;
  text-decoration: none;
}
.a-line {
  display: inline-block;
  vertical-align: middle;
  height: 13px;
  width: 1px;
  background-color: white;
  margin-right: 8px;
}
.site-logo {
  display: flex;
  align-items: center;
}

.site-logo-img {
  width: 128px;
  height: 44px;
  display: inline-block;
  /* 🔴 [Compass高危] S3/Venus 读取类域名，读操作当前可使用香港CDN，但需要关注后续团队规范 */
  background-image: url("https://img-ap-hongkong.mykeeta.net/osgeujiemo/396b50e6e2ffa5015126eb61f5c737495032.png");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
}

.logo-box {
  display: inline-block;
  vertical-align: middle;
  width: 118px;
  height: 35px;
  margin-left: 1px;
  margin-right: 4px;
  margin-top: -4px;
}
.logo {
  width: 100%;
}

.vss-header {
  height: 80px !important;
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.04);
  padding: 0 16px;
}
.supplier-name {
  width: 268px;
  /* 垂直对齐 */
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.common-style-for-link {
  margin-right: 20px;
  font-size: 14px;
  border: 0;
  position: relative;
  color: #fff;
  cursor: pointer;
  text-decoration: none;
  transition: none;
  font-weight: 400;
}
.common-style-for-link:hover {
  color: #fff;
  opacity: 0.7;
  text-decoration: none;
}

.report {
  margin-right: 20px;
}

.mtd-menu {
  width: auto;
}
/* :deep() .mtd-submenu-title {
  padding: 0 0 0 12px;
} */
:deep() .mtd-submenu-text {
  display: flex !important;
  align-content: center !important;
}
.mtdicon-avatar-o {
  color: #01a65c;
  font-size: 20px;
  line-height: 30px;
}
.login-menu {
  display: flex;
}
.login-name {
  color: #333;
  margin-left: 5px;
  height: 30px;
  line-height: 30px;
}
</style>